<template>
    <div style="padding-top: 40px">
        <div class="room-info first">
            <div class="room-info-key">房号</div>
            <div class="room-info-value">{{ info.roomNumber || ""}}</div>
        </div>
        <div class="room-info">
            <div class="room-info-key">户型</div>
            <div class="room-info-value">{{ info.houseType || ""}}</div>
        </div>
        <div class="room-info">
            <div class="room-info-key">房间结构</div>
            <div class="room-info-value">{{ dict.roomLayout.val(info.roomLayout) || ""}}</div>
        </div>
        <div class="room-info">
            <div class="room-info-key">销售状态</div>
            <div class="room-info-value">{{ dict.houseStatus.val(info.houseStatus) || ""}}</div>
        </div>
        <div class="room-info">
            <div class="room-info-key">租售类型</div>
            <div class="room-info-value">{{ dict.leaseType.val(info.leaseType) || ""}}</div>
        </div>
        <div class="room-info">
            <div class="room-info-key">建筑面积</div>
            <div class="room-info-value">{{ info.buildArea || "" | currency}}</div>
        </div>
        <div class="room-info">
            <div class="room-info-key">套内面积</div>
            <div class="room-info-value">{{ info.insideArea || "" | currency}}</div>
        </div>
        <div class="room-info">
            <div class="room-info-key">建筑单价</div>
            <div class="room-info-value">{{ info.buildAveragePrice || "" | currency}}</div>
        </div>
        <div class="room-info">
            <div class="room-info-key">套内单价</div>
            <div class="room-info-value">{{ info.insideAveragePrice || "" | currency}}</div>
        </div>
        <div class="room-info">
            <div class="room-info-key">标准总价</div>
            <div class="room-info-value">{{ info.standardPrice || "" | currency}}</div>
        </div>
        <div class="room-info spike">
            <div class="room-info-key">秒杀总价</div>
            <div class="room-info-value spike">{{ info.spikePrice || "" | currency}}</div>
        </div>
    </div>
</template>
<script>
import Dict from '@/utils/dict'
export default {
    props: {
        info: {
            type: [Object],
            default: () => {}
        }
    },

    data() {
        return {
            dict: {
                houseStatus: Dict.NULL,
                leaseType: Dict.NULL,
                roomLayout: Dict.NULL,
            }
        }
    },
    computed: {},
    methods: {},
    created() {
        Dict.get(['house_status', 'lease_type', 'room_layout']).then(dict => {
            Object.keys(this.dict).forEach(key => {
                this.dict[key] = dict[key]
            })
        })
    }
}
</script>
<style lang="less" scoped>
@room-border: #dadada;
.room-info {
    display: flex;
    border: 1px solid @room-border;
    border-top: 0;
    &.first {
        border-top: 1px solid @room-border;
    }
    &.spike {
        line-height: 32px;
    }
    &-key {
        width: 100px;
        padding: 12px;
        background-color: #f2f2f2;
        text-align: center;
    }
    &-value {
        flex: 1;
        padding: 12px;
        &.spike {
            color: #fb6340;
            font-size: 24px;
        }
    }
}
</style>
